import script from "./user.vue?vue&type=script&lang=ts&setup=true"
export * from "./user.vue?vue&type=script&lang=ts&setup=true"

import "./user.scss?vue&type=style&index=0&id=f9a3e4dc&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9a3e4dc"]])

export default __exports__